import React from 'react'
import { makeStyles } from '@material-ui/core/styles';

const widgetWidth = 60;
const useStyles = makeStyles(theme => ({
  root: {
    width: widgetWidth,
    display: 'inline-block',
    overflow: 'hidden',
    borderRadius: 3,
  },
  container: {
    height: '100%',
    background: '#e1e1e1',
    position: 'relative',
    width: '100%',
    boxSizing: 'border-box'
  },
  span: {
    display: 'inline-block',
    background: theme.palette.primary.light,
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    width: 0,
    overflow: 'hidden',
  },
  text: {
    fontFamily: 'Roboto',
    fontSize: 12
  },
  percent: {
    position: 'absolute',
    color: theme.palette.primary.dark,
    display: 'inline-block',
    top: 3,
    left: 0,
    width: widgetWidth,
    textAlign: 'center',
    fontWeight: 400,
  }
}));

function CourseListProgress(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <span className={classes.percent}>{props.progress}%</span>
        <span className={classes.span} style={{ width: props.progress + '%' }}>
          <span className={classes.percent} style={{ color: '#fff' }}>{props.progress}%</span>
        </span>

      </div>
    </div>
  );

}

export default CourseListProgress;